export default __webpack_public_path__ + "static/media/kobe-collection_mobile.7cb6fe28.png";